// Generated types for MBSE_Attribute
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { AttributeDefinitionReadAPI, AttributeDefinitionWriteAPI } from '../../sysml/types/attributedefinition';
import { AttributeDefinitionReadAPISchemaObject, AttributeDefinitionWriteAPISchemaObject } from '../../sysml/types/attributedefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_AttributeReadAPI extends AttributeDefinitionReadAPI {
}

export interface MBSE_AttributeWriteAPI extends AttributeDefinitionWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_AttributeReadAPISchema: z.ZodType<MBSE_AttributeReadAPI> = AttributeDefinitionReadAPISchemaObject.extend({}).passthrough();

export const MBSE_AttributeWriteAPISchema: z.ZodType<MBSE_AttributeWriteAPI> = AttributeDefinitionWriteAPISchemaObject.extend({}).passthrough();
